import { render, staticRenderFns } from "./CreateNewsPage.vue?vue&type=template&id=7e95218b&scoped=true&"
import script from "./CreateNewsPage.vue?vue&type=script&lang=js&"
export * from "./CreateNewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e95218b",
  null
  
)

export default component.exports